import styles from "./CompareWidget.module.css";
import classNames from "classnames";
import { useState, useCallback } from "react";
import LoadingIndicator from "../LoadingIndicator";
import { Link } from "react-router-dom";
import { useCompare } from "../../context/CompareContext";
import { useMutation } from "@apollo/client";
import { useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import placeholder from "../../assets/images/placeholder.webp";
import { FaRupeeSign } from "react-icons/fa";
import { REMOVE_PRODUCTS_FROM_COMPARE_LIST } from "../../Pregrine/ComparePage/comparePage.gql";
import { getProductImage } from "../../utility/getProductImage";
import { formatIndianNumber } from "../../utility/formatPrice";

function getProductPrice(item) {
  let value = {};
  if (item["__typename"].toLowerCase() === "bundleproduct") {
    const totalPrice = item.items[0].options.reduce((acc, curr) => {
      return (
        acc +
        curr.product.price_range.maximum_price.regular_price.value *
          curr.quantity
      );
    }, 0);

    const afterDiscount = item.items[0].options.reduce((acc, curr) => {
      return (
        acc +
        curr.product.price_range.maximum_price.final_price.value * curr.quantity
      );
    }, 0);

    value = {
      regularPrice: { value: totalPrice },
      discountPrice: { value: afterDiscount },
    };
  } else {
    const regularPrice = item.price_range.minimum_price.regular_price;
    const discountPrice =
      item.price_range.minimum_price.discount &&
      !!item.price_range.minimum_price.discount.amount_off &&
      item.price_range.minimum_price.final_price;
    value = {
      regularPrice,
      discountPrice,
    };
  }
  return value;
}

const CompareWidget = () => {
  const [showCompare, setShowCompare] = useState(false);
  const { data, loading, setData } = useCompare();
  const { addToast } = useToasts();
  const { compareListId } = useSelector((state) => state.compareListSlice);

  const showSuccessToast = useCallback(() => {
    addToast("Item successfully remove from compare list.", {
      appearance: "success",
      autoDismiss: true,
      style: {
        backgroundColor: "#027B51" /* Custom background color */,
        color: "#fff" /* Custom text color */,
      },
    });
  }, []);

  const showErrorToast = useCallback((msg) => {
    addToast("Unable to remove item from compare list.", {
      appearance: "error",
      autoDismiss: true,
      style: {
        backgroundColor: "#DB1F00",
        color: "#fff",
      },
    });
  }, []);

  const [removeCompareList, { data: updatedData, error }] = useMutation(
    REMOVE_PRODUCTS_FROM_COMPARE_LIST,
    {
      onCompleted: (data) => {
        if (data && data.removeProductsFromCompareList) {
          setData(data.removeProductsFromCompareList.items);
          showSuccessToast();
          if (data.removeProductsFromCompareList.items.length === 0) {
            setShowCompare(false);
          }
        } else showErrorToast(error.message);
      },
      onError: (err) => {
        showErrorToast(err.message);
      },
    }
  );

  return (
    <section>
      {!loading && data && data.length > 0 ? (
        <div className={styles.content}>
          <button
            className={classNames(styles["btn-open"], {
              [styles.Close]: !showCompare,
            })}
            onClick={() => setShowCompare(!showCompare)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19.21"
              height="24"
              viewBox="0 0 1024 1280"
            >
              <path
                fill="#111111"
                d="M1011 1056q0 13-10 23l-50 50q-10 10-23 10t-23-10L512 736l-393 393q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l466 466q10 10 10 23m0-384q0 13-10 23l-50 50q-10 10-23 10t-23-10L512 352L119 745q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l466 466q10 10 10 23"
              />
            </svg>
            Compare Products
            {data && data.length > 0 && (
              <span className={styles.itemDot}>{data.length}</span>
            )}
          </button>
          <div
            className={classNames(styles.wrapper, {
              [styles.wrapperOpne]: showCompare,
            })}
          >
            <div
              className={classNames(styles.compareContainer, {
                [styles.compareOpen]: showCompare,
              })}
            >
              <div className="container">
                <div className="row">
                  {!loading ? (
                    data && data.length > 0 ? (
                      data.map((item, idx) => {
                        const value = getProductPrice(item?.product);
                        const { discountPrice, regularPrice } = value;
                        return (
                          <div className="col-lg-3" key={idx}>
                            <div className={styles["box-compare"]}>
                              <button
                                onClick={() => {
                                  removeCompareList({
                                    variables: {
                                      CompareListId: compareListId,
                                      productId: item.product.id,
                                    },
                                  });
                                }}
                                className={styles["close-compare"]}
                              >
                                x
                              </button>
                              <div className={styles["img-comp"]}>
                                <Link to={`/product/${item.product.url_key}`}>
                                  <img
                                    src={
                                      getProductImage(item.product) ||
                                      placeholder
                                    }
                                    className={styles["img-fluid"]}
                                  />
                                </Link>
                              </div>
                              <h4>{item.product.name}</h4>
                              {/* <p>
                            <small>Order no. 30866</small>
                          </p> */}
                              <h3>
                                <div className={styles.priceWrapper}>
                                  <div className={styles.pricetag}>
                                    {discountPrice ? (
                                      <>
                                        <span className={styles.mrpText}>
                                          MRP
                                        </span>
                                        <span className={styles.discountPrice}>
                                          <FaRupeeSign />
                                          <span>
                                            {formatIndianNumber(
                                              regularPrice.value
                                            )}
                                          </span>
                                        </span>
                                        <span>
                                          <FaRupeeSign />
                                          <span>
                                            {formatIndianNumber(
                                              discountPrice.value
                                            )}
                                          </span>
                                        </span>
                                        <span className={styles.discountOff}>
                                          {item.product[
                                            "__typename"
                                          ].toLowerCase() === "bundleproduct"
                                            ? ` ${(
                                                ((regularPrice.value -
                                                  discountPrice.value) *
                                                  100) /
                                                regularPrice.value
                                              ).toFixed(2)} % OFF`
                                            : `${item?.product?.price_range?.minimum_price?.discount?.percent_off} % OFF`}
                                        </span>
                                      </>
                                    ) : (
                                      <span>
                                        MRP
                                        <FaRupeeSign />
                                        <span>
                                          {formatIndianNumber(
                                            regularPrice.value
                                          )}
                                        </span>
                                      </span>
                                    )}
                                  </div>
                                  <small className={styles.incl}>
                                    (Incl. of all taxes)
                                  </small>
                                </div>
                              </h3>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div cla className={styles.empty}>
                        No Products to Compare
                      </div>
                    )
                  ) : (
                    <div className="col-lg-9">
                      <LoadingIndicator />
                    </div>
                  )}
                  {data && data.length > 1 ? (
                    <div className="col-lg-3">
                      <div
                        className={classNames(
                          styles["box-compare"],
                          styles.four
                        )}
                      >
                        <div>
                          <h4>Select up to 3 products to compare</h4>
                          <button
                            onClick={() => {
                              removeCompareList({
                                variables: {
                                  CompareListId: compareListId,
                                  productId: data.map(
                                    (item) => item.product.id
                                  ),
                                },
                              });
                              setShowCompare(false);
                            }}
                            className={styles.clearAllBtn}
                          >
                            X Clear all
                          </button>
                          <Link
                            to="/compare-page"
                            className={styles.comparebtn}
                          >
                            Compare
                          </Link>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </section>
  );
};

export default CompareWidget;
